/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Form_LabelInputs */

const en_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell Check Form`)
};

const fr_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de verification orthographique`)
};

const de_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtschreibprüfungsformular`)
};

const it_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di controllo ortografico`)
};

const ru_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма проверки орфографии`)
};

const es_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de revisión ortográfica`)
};

const zh_cn2_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拼写检查表单`)
};

const ja_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェックフォーム`)
};

const hi_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी जाँच प्रपत्र`)
};

const pt_pt2_spellcheck_form_label = /** @type {(inputs: Spellcheck_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de verificação ortográfica`)
};

/**
* | output |
* | --- |
* | "Spell Check Form" |
*
* @param {Spellcheck_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_form_label = /** @type {((inputs?: Spellcheck_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_form_label(inputs)
	if (locale === "de") return de_spellcheck_form_label(inputs)
	if (locale === "it") return it_spellcheck_form_label(inputs)
	if (locale === "ru") return ru_spellcheck_form_label(inputs)
	if (locale === "es") return es_spellcheck_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_form_label(inputs)
	if (locale === "ja") return ja_spellcheck_form_label(inputs)
	if (locale === "hi") return hi_spellcheck_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_form_label(inputs)
	return en_spellcheck_form_label(inputs)
});